import * as R from 'ramda'
import { tasks, properties, repairmen } from './entities'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'

let repairmenFilters = state => state.repairmenFilters

let filteredRepairmen = (repairmenFilters) => (repairman) => {
	if(repairman.distance && repairman.distance >= 50) return false
	if(repairmenFilters.category == 'All') return true
	if(repairmenFilters.category != 'All' && repairmenFilters.category != '' && repairman.categories && !~repairman.categories.indexOf(repairmenFilters.category)) return false
	return true
}

export default createSelector(
	[properties, tasks, repairmen, repairmenFilters]
  , (properties, tasks, repairmen, repairmenFilters) => R.filter(
		filteredRepairmen(repairmenFilters)
	  , R.map((repairman) => ({
				...repairman
			  , tasksActive: R.values(R.filter(task => !!~repairman.tasks.indexOf(task._id) && !task.done, tasks))
			  , tasksDone: R.values(R.filter(task => !!~repairman.tasks.indexOf(task._id) && task.done, tasks))
			  , distance: (() => {
					if(
						!!properties[repairmenFilters.property]
						&& !!repairman.cors
						&& repairman.cors.lat
						&& repairman.cors.lng
						&& repairman.cors.lat != ''
						&& repairman.cors.lng != ''
						&& !!properties[repairmenFilters.property].cors
						&& properties[repairmenFilters.property].cors.lat != ''
						&& properties[repairmenFilters.property].cors.lng != ''
					){
					  	let R = 3958.756;
					  	let dLat = (properties[repairmenFilters.property].cors.lat-repairman.cors.lat)* Math.PI / 180;
					  	let dLon = (properties[repairmenFilters.property].cors.lng-repairman.cors.lng)* Math.PI / 180;
					  	let lat1 = repairman.cors.lat * Math.PI / 180;
					  	let lat2 = properties[repairmenFilters.property].cors.lat * Math.PI / 180;

					  	let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
					  			Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
					  	let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
					  	let d = R * c / 1.60934;
						return d.toFixed(2)
					} else if(!!properties[repairmenFilters.property]){
						return 9999
					}else{
						return 0
					}
			  })()
			})
		  , repairmen
		)
	)
)



// WEBPACK FOOTER //
// ./src/selectors/repairmen.js